import { GameConfig } from "@/config/GameConfig";

/**
 * `maneuverSpeedWeight = clamp(baseMovementInterval / effectiveMovementInterval, min, max)`
 * - a shorter effective interval (faster movement) means a larger ratio,
 * i.e. a higher weight. Deliberately derived from the engine's own
 * millisecond intervals, never from input/keyboard timing - a keyboard
 * player and a touch player moving at the same in-game speed always get
 * the exact same weight.
 *
 * Deliberately named apart from `SpeedEngine`'s own composed movement
 * boost factor (`src/core/SpeedEngine.ts`) - this is Skill Score's own,
 * separate weighting of how much a credited maneuver is worth, not a
 * component of the gameplay Speed Engine itself. `effectiveMovementIntervalMs`
 * should always be the Speed Engine's current INTERPOLATED step interval
 * (`SpeedEngine.currentStepMs`), the same value movement ticks actually
 * use, so Skill Score can never silently disagree with what the player
 * perceives.
 */
export function computeManeuverSpeedWeight(baseMovementIntervalMs: number, effectiveMovementIntervalMs: number): number {
  const { min, max } = GameConfig.scoring.maneuverSpeedWeight;
  const raw = baseMovementIntervalMs / effectiveMovementIntervalMs;
  return Math.min(max, Math.max(min, raw));
}
